export default __webpack_public_path__ + "static/media/master_filter.7b60944d.svg";